module.exports = __webpack_public_path__ + "static/media/bouldering-after.801822d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/photo-editing/bouldering-after.jpg
// module id = 373
// module chunks = 0